import { ArrowIcon, DeleteIcon, FireIcon, IconCustom } from "@/assets/icons";
import styles from "./CusContent.module.scss";
import useEffectStore, { ActionStates } from "@/stores/effectStore";
import { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import clsx from "clsx";
import { GenerateButton } from "@/components";
import { useTranslation } from "react-i18next";
import { customConfirm } from "@/components/confirm/modal";
import { getI18nLang } from "@/utils";
import { I18nLangMap } from "@/constants";
import { useImperativeHandle } from "react";
import { forwardRef } from "react";
import { ForwardedRef } from "react";
import { useIsMobile } from "@/hooks";

interface InputType {
  maxLength?: number;
  title: string;
  onChange: (value: string) => void;
}
const Input = (props: InputType) => {
  const { title, onChange, maxLength = 12 } = props;

  //是否在使用拼音输入法
  const hasUsePinYin = useRef({
    status: false,
    value: "",
  });

  const inputDoms = useRef<HTMLInputElement>(null);
  return (
    <input
      // maxLength={15}
      placeholder={title}
      onCompositionStart={() => (hasUsePinYin.current.status = true)} // 输入法开始组合
      onCompositionEnd={(el) => {
        hasUsePinYin.current.status = false;
        let str = (el.target as HTMLInputElement).value;
        str = str.replace(/[a-z]/g, (match) => match.toUpperCase());
        let doms = el.target as HTMLInputElement;
        const start = doms.selectionStart;
        const end = doms.selectionEnd;
        str = str.substring(0, maxLength);
        inputDoms.current!.value = str.replace(/[^A-Za-z0-9\s]/g, "");
        doms.setSelectionRange(start, end);
        // 手动触发一次 input 处理
        onChange(inputDoms.current!.value);
      }}
      onInput={(el) => {
        if (hasUsePinYin.current.status) {
          return;
        }
        let doms = el.target as HTMLInputElement;
        const start = doms.selectionStart;
        const end = doms.selectionEnd;

        let str = (el.target as HTMLInputElement).value;
        //去掉幽灵字符
        str = str.replace(/[\u00AD\u200B\u200C\u200D]/g, "");

        str = str.replace(/[a-z]/g, (match) => match.toUpperCase());
        str = str.substring(0, maxLength);
        inputDoms.current!.value = str.replace(/[^A-Za-z0-9\s]/g, "");
        doms.setSelectionRange(start, end);
        onChange(inputDoms.current!.value);
      }}
      ref={inputDoms}
      className={styles["cus-text-input"]}
      type="text"
    />
  );
};

const TEXT_AREA_MAX_LENGTH = 60;

interface PropsType {
  className?: string;
  headerClassName?: string;
  onClickGenerate?: () => void;
}
export interface RefType {
  handleClose: () => void;
  setCollectionCusInfo: (value: ActionStates["collectionCusInfo"]) => void;
}
const LeftCusContent = (props: PropsType, ref: ForwardedRef<RefType>) => {
  const { t, i18n } = useTranslation();
  const collectionCusInfo = useEffectStore((state) => state.collectionCusInfo);
  const setCollectionCusInfo = useEffectStore(
    (state) => state.setCollectionCusInfo
  );
  const customPanel = useEffectStore((state) => state.customPanel);
  const customEffect = useEffectStore((state) => state.customPanel?.target);
  const isMobile = useIsMobile();
  // 判断显示隐藏，有可能是空字符，然后不会显示了
  const showObject = useMemo(() => {
    let obj: { [key: string]: boolean } = {};
    customPanel?.target?.expand?.forEach((items) => {
      if (items?.enabled) {
        obj[items.key] = true;
      }
    });
    return obj;
  }, [customEffect]);
  const obj = useMemo(() => {
    let obj: { [key: string]: string } = {};
    customPanel?.target?.expand?.forEach((items) => {
      if (items?.enabled) {
        obj[items.key] = items.value;
      }
    });
    return obj;
  }, [customEffect]);

  const firsetRecord = useRef<ActionStates["collectionCusInfo"]>({
    name: obj?.names ?? "",
    preset: obj?.preset ?? "",
    profession: obj?.profession ?? "",
  });
  /** 首次设置默认 */
  useLayoutEffect(() => {
    setCollectionCusInfo({
      name: obj?.names ?? "",
      preset: obj?.preset ?? "",
      profession: obj?.profession ?? "",
    });
  }, []);

  const [presetError, setPresetError] = useState(false);
  const recommedArr =
    obj?.recommend
      ?.split(",")
      .map((item) => item.trim())
      .filter((item) => item) ?? [];
  const [focus, setFocuse] = useState(false);
  const textArea = useRef<HTMLTextAreaElement>(null);
  const firstOpen = useRef(false);
  useEffect(()=>{
    
  },[isMobile])

  function handel_capture(el: MouseEvent) {
    if (
      !document
        .querySelector(`.${styles["cus-text-textarea-fra"]}`)
        ?.contains(el.target as HTMLElement)
    ) {
      setFocuse(false);
      window.removeEventListener("click", handel_capture);
    }
  }

  function handel_mousedown() {
    textArea.current?.focus();
    window.addEventListener("click", handel_capture, { capture: true });
  }
  const { className, headerClassName } = props;
  const isCustom = customEffect?.type === "custom";

  const handleClose = async () => {
    try {
      let arr = Object.keys(firsetRecord.current);
      for (let i = 0; i < arr.length; i++) {
        if (
          firsetRecord.current[
            arr[i] as keyof ActionStates["collectionCusInfo"]
          ] !==
          collectionCusInfo[arr[i] as keyof ActionStates["collectionCusInfo"]]
        ) {
          const isToMuti = await customConfirm(t("back_to_tips"), {
            cancel: "back_to_tips_cancel",
            confirm: "back_to_tips_confirm",
          });
          if (isToMuti) {
            useEffectStore.getState().setCustomPanel(false);
            return true;
          }
          return false;
        }
      }
      useEffectStore.getState().setCustomPanel(false);
      return true;
    } catch {}
    return true;
  };

  useImperativeHandle(ref, () => {
    return {
      handleClose: handleClose,
      setCollectionCusInfo: setCollectionCusInfo,
    };
  });

  const showDoms = useRef<HTMLDivElement>(null);

  return (
    <div className={clsx(styles["cus-container"], className)}>
      <div
        onClick={handleClose}
        className={clsx(styles["cus-header"], headerClassName)}
      >
        <ArrowIcon width={24} />
        <span>{t("back_to_list")}</span>
      </div>
      <div className={styles["cus-content-scroll-fra"]}>
        <div className={styles["cus-style-title"]}>{t("style_title")}</div>
        <div className={styles["cus-style-show"]}>
          <div className={styles["show-img"]}>
            {isCustom ? (
              <IconCustom />
            ) : (
              <img src={customPanel?.target?.coverUrl} alt="" />
            )}
          </div>
          {getI18nLang(
            customPanel?.target?.i18nAttr ?? [],
            I18nLangMap[i18n.language]
          ) || customPanel?.target?.title}
        </div>
        {showObject?.names && (
          <>
            <div className={styles["cus-style-title"]}>
              {t("custom_name_title")}
            </div>
            <Input
              onChange={(value) => {
                setCollectionCusInfo({
                  ...collectionCusInfo,
                  name: value,
                });
              }}
              title={t("custom_name_seat")}
            />
          </>
        )}
        {showObject?.profession && (
          <>
            <div className={styles["cus-style-title"]}>
              {t("custom_profession_title")}
            </div>
            <Input
              onChange={(value) => {
                setCollectionCusInfo({
                  ...collectionCusInfo,
                  profession: value,
                });
              }}
              title={t("custom_profession_seat")}
            />
          </>
        )}
        {showObject?.preset && (
          <>
            <div className={styles["cus-style-title"]}>
              {t("custom_perset_title")}
            </div>
            <div
              onMouseDown={handel_mousedown}
              onClick={() => {
                textArea.current?.focus();
              }}
              onAnimationEnd={() => {
                setPresetError(false);
              }}
              className={clsx(
                styles["cus-text-textarea-fra"],
                focus && styles["cus-text-textarea-active"],
                presetError && styles["cus-text-textarea-error"]
              )}
            >
              {/* {presetError && (
          <div className={styles["cus-text-textarea-error-tips"]}>
            The image you added is in the wrong format! Supported uploaded image
            formats: JPG, JPEG and PNG.
          </div>
        )} */}
              <textarea
                placeholder={presetError ? "" : t("custom_perset_seat")}
                ref={textArea}
                maxLength={TEXT_AREA_MAX_LENGTH}
                onInput={(el) => {
                  setCollectionCusInfo({
                    ...collectionCusInfo,
                    preset: (el.target as HTMLInputElement).value,
                  });
                }}
                onFocus={() => {
                  setFocuse(true);
                  setPresetError(false);
                  firstOpen.current = true;
                }}
                value={collectionCusInfo.preset}
                className={styles["cus-text-textarea"]}
              />
              <div
                style={{
                  visibility:
                    collectionCusInfo.preset.length > 0 ? "visible" : "hidden",
                }}
                className={styles["cus-text-textarea-info"]}
              >
                {collectionCusInfo.preset.length}/{TEXT_AREA_MAX_LENGTH}
                <span></span>
                <DeleteIcon
                  onClick={() => {
                    setCollectionCusInfo({
                      ...collectionCusInfo,
                      preset: "",
                    });
                  }}
                  width={16}
                />
              </div>
            </div>
          </>
        )}

        {recommedArr.length > 0 && showObject?.preset && (
          <div
            className={clsx(styles["popular-tags-fra"])}
            style={{
              height: (firstOpen.current || isMobile)
                ? `${showDoms.current?.offsetHeight! + 16 || 0}px`
                : 0,
            }}
          >
            <div
              style={{
                marginTop: "16px",
              }}
              ref={showDoms}
            >
              <div className={styles["popular-tags-title"]}>
                <FireIcon width={16} />
                {t("custom_recommend_title")}
              </div>
              <div className={styles["popular-tags-inner"]}>
                {recommedArr.map((items) => {
                  return (
                    <div
                      onClick={() => {
                        if(!isMobile){
                          textArea.current?.focus();
                        }
                        const centerStr = ", ";
                        let str =
                          collectionCusInfo.preset.length > 0
                            ? collectionCusInfo.preset + centerStr + items
                            : items;
                        if (!textArea.current) {
                          return;
                        }
                        const start = textArea.current.selectionStart;
                        let nums = 0;
                        if (start <= 0) {
                          str =
                            collectionCusInfo.preset.length === 0
                              ? items
                              : items + centerStr + collectionCusInfo.preset;
                          nums = items.length + 1;
                        } else if (start >= collectionCusInfo.preset.length) {
                          str =
                            collectionCusInfo.preset +
                            (collectionCusInfo.preset[
                              collectionCusInfo.preset.length - 1
                            ] === ","
                              ? ""
                              : centerStr) +
                            items;
                          nums = items.length + centerStr.length;
                        } else {
                          const lastStr =
                            collectionCusInfo.preset[start - 1].trim();
                          const lastTwoStr =
                            collectionCusInfo.preset[start - 2].trim();
                          if (lastStr === ",") {
                            str =
                              collectionCusInfo.preset.substring(0, start) +
                              items +
                              centerStr +
                              collectionCusInfo.preset.substring(start);
                            nums = items.length + centerStr.length;
                          } else if (lastStr === "" && lastTwoStr === ",") {
                            str =
                              collectionCusInfo.preset.substring(0, start) +
                              items +
                              centerStr +
                              collectionCusInfo.preset.substring(start);
                            nums = items.length + centerStr.length;
                          } else {
                            str =
                              collectionCusInfo.preset.substring(0, start) +
                              items +
                              collectionCusInfo.preset.substring(start);
                            nums = items.length;
                          }
                        }
                        if (str.length > TEXT_AREA_MAX_LENGTH) {
                          return;
                        }
                        setCollectionCusInfo({
                          ...collectionCusInfo,
                          preset: str,
                        });
                        if(!isMobile){
                          requestAnimationFrame(() => {
                            if (textArea.current) {
                              textArea.current.setSelectionRange(
                                start + nums,
                                start + nums
                              );
                            }
                          });
                        }
                        
                      }}
                      key={items}
                    >
                      {items}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
        <GenerateButton
          className={styles["gen-btn"]}
          beforeClick={() => {
            console.log(useEffectStore.getState().collectionCusInfo);
            useEffectStore.getState().setCurrentEffect(customPanel.target!);

            return true;
          }}
          startGenerate={() => props.onClickGenerate?.()}
        />
      </div>
    </div>
  );
};

export default forwardRef<RefType, PropsType>(LeftCusContent);
